var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"wrapped-static divfix"},[_c('v-progress-circular',{attrs:{"value":_vm.porcentaje,"color":"primary","size":300,"pt-7":"","width":30}},[_c('h1',[_vm._v(_vm._s(_vm.value)+"/"+_vm._s(_vm.total))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }